/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_DogInputs */

const en_road_dude_prompt_dog = /** @type {(inputs: Road_Dude_Prompt_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dog`)
};

const zh_road_dude_prompt_dog = /** @type {(inputs: Road_Dude_Prompt_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`狗狗`)
};

/**
* | output |
* | --- |
* | "Dog" |
*
* @param {Road_Dude_Prompt_DogInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_dog = /** @type {((inputs?: Road_Dude_Prompt_DogInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_DogInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_dog(inputs)
	return zh_road_dude_prompt_dog(inputs)
});
export { road_dude_prompt_dog as "road_dude.prompt.dog" }